import { Pagewrapper, SearchBar } from "../../components";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const Jurisprudencia = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row className="justify-content-md-center">
        <Col sm={6}>
          <h1 className="mt-5 text-center">Jurisprudência</h1>
          <p className="mt-2 text-center">
            Consulta unificada de jurisprudência com resultados abrangentes e
            atualizados.
          </p>
        </Col>
      </Row>
      <Row className="justify-content-md-center mt-5">
        <Col sm={6}>
          <SearchBar />
        </Col>
      </Row>
    </Container>
  </Pagewrapper>
);

export default Jurisprudencia;
